"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuctionTape = void 0;
const React = __importStar(require("react"));
const highlight_png_1 = __importDefault(require("@assets/highlight.png"));
require("./styles.scss");
const token_hooks_1 = require("@hooks/token.hooks");
const nft_token_card_list_1 = require("@components/nft-token-card-list");
const translation_hooks_1 = require("@hooks/translation.hooks");
const routing_hooks_1 = require("@hooks/routing.hooks");
const icons_1 = require("@shared-modules/components/icons");
const http_1 = require("@utils/http");
const AuctionTape = () => {
    const { list: lastAuctionAndLotteries } = (0, token_hooks_1.useTokenListByFilter)({
        types: ["auction"],
        sortingProperty: "created",
        sorting: "asc",
    }, { size: 10 });
    const exploreHotAuctionRedirect = (0, routing_hooks_1.useRedirectTo)("/explore" + (0, http_1.parseToUrlQuery)({ type: "auction" }), true);
    const translator = (0, translation_hooks_1.usePagesTranslation)("mainPage.auctionTape");
    return (React.createElement("div", { className: "c-main-page-auction-tape" },
        React.createElement("div", { className: "c-main-page-auction-tape__info" },
            React.createElement("div", { className: "c-main-page-auction-tape__title", style: { backgroundImage: `url(${highlight_png_1.default})` } }, translator("title")),
            React.createElement("div", { className: "c-main-page-auction-tape__description" },
                translator("description"),
                React.createElement("div", { onClick: exploreHotAuctionRedirect, className: "c-main-page-auction-tape__link" },
                    translator("moreLink"),
                    " ",
                    React.createElement(icons_1.ArrowRight, { color: "red" })))),
        React.createElement("div", { className: "c-main-page-auction-tape__list" },
            React.createElement(nft_token_card_list_1.NFTTokenCardList, { list: lastAuctionAndLotteries }))));
};
exports.AuctionTape = AuctionTape;
exports.default = exports.AuctionTape;
